import React, { useEffect, useState } from "react";
import { RedoOutlined } from "@ant-design/icons";
import { fetchRecommendKindsCompare } from "@Services/kindsum";
import OverflowTooltip from "@Components/overflowTooltip";
interface IProps {
  kindId: number;
}
export interface IList {
  brandId: number;
  brandName: string;
  compareCount: number;
  compareModelYearIds: string;
  kindId: number;
  kindName: string;
  price: string;
  thumb: string;
}

const Car: React.FC<IProps> = ({ kindId }) => {
  const pageSize = 5;
  const [listData, setListData] = useState<IList[]>([]);
  const [visibleCount, setVisibleCount] = useState(1);

  // 计算显示的数据
  const startIndex = (visibleCount - 1) * pageSize; // 计算起始索引
  const endIndex = visibleCount * pageSize; // 计算结束索引
  const paginatedData = listData.slice(startIndex, endIndex); // 获取分页数据

  const getListData = async () => {
    try {
      const res: any = await fetchRecommendKindsCompare({
        kindId,
        limit: 20,
      });
      if (res?.status === 12000) {
        setListData(res?.data?.list || []);

      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadMore = () => {
    if (endIndex >= listData.length) {
      setVisibleCount(1);
    } else {
      setVisibleCount(visibleCount + 1);
    }
  };

  useEffect(() => {
    getListData();
  }, []);

  if (listData.length === 0) {
    return null;
  }

  return (
    <div className='w-280 border-1 border-solid border-[#E8E8E8] rounded-4 flex flex-col items-center relative mb-40'>
      {listData.length >= 6 && <RedoOutlined
        className="absolute top-16 right-10 text-20"
        style={{ transform: 'rotate(300deg)' }}
        onClick={loadMore}
        id={`tracking-compareMore`}
      />}
      <h3 className='text-20 font-medium text-[#333] leading-30 w-full text-left pl-10 pt-10'>推薦車款比較</h3>

      {paginatedData.map((item, index) => (
        <div key={index} className="flex flex-col items-center justify-center w-full">
          <a href={`/kind-summary/${item.kindId}`} target="_blank" className="flex items-center justify-start w-full h-[78px]">
            <img src={item.thumb} alt={item.kindName} className="w-90 h-60 mr-4" />
            <div className="flex flex-col items-start justify-center text-14">

              <OverflowTooltip tooltipTitle={`${item.brandName} ${item.kindName}`}>
                <p className="text-[#333] leading-20 w-[176px] line-clamp-1 mb-6 font-[600]">{item.brandName} {item.kindName}</p>
              </OverflowTooltip>
              
              <div className=" flex items-center justify-between w-full">
                <span className="text-[#FF3232] leading-20 font-[600]">{item.price}</span>
                <a
                  id={`tracking-compareToPk`}
                  data-id={item.compareModelYearIds}
                  href={`/pk/comprehensive?myids=${item.compareModelYearIds}`}
                  target="_blank"
                  className="text-12 w-[64px] h-[24px] rounded-4 flex items-center justify-center border-1 border-solid border-[#3264FF] text-[#3264FF] hover:text-[#3264FF]"
                  onClick={(event) => {
                    event.stopPropagation();
                  }}
                >
                  +比較
                </a>
              </div>
            </div>

          </a>
          {index !== paginatedData.length - 1 && <i className="w-[262px] h-[1px] bg-[#E8E8E8] block" />}
        </div>
      ))}
    </div>
  );
};

export default Car;
